import React, { useState, useCallback, Dispatch, SetStateAction } from "react";
import fetch from "unfetch";
import { useLoads } from "react-loads";
import Timeout from "await-timeout";
import { toast } from "react-toastify";

import {
  Container,
  TextButton,
  Button,
  GridContainer,
  P,
} from "@util/standard";
import { useStore } from "@state/store";
import { TextInput } from "@global";
import { navigate } from "gatsby-link";
import { updateCustomer } from "@util/getFirebase";

interface Props {
  setShowRegister: Dispatch<SetStateAction<boolean>>;
}

export const Register = ({ setShowRegister }: Props) => {
  const [showRegisterComplete, setShowRegisterComplete] = useState(false);
  const [passwordField1, setPasswordField1] = useState("");
  const [passwordField2, setPasswordField2] = useState("");
  const form = React.createRef<HTMLFormElement>();
  const [attempts, setAttempts] = useState(0);
  const { closeDrawer, shopify } = useStore();

  const handleRegister = useCallback(
    async (email, password, firstName, lastName, shopifyObj) => {
      setAttempts(attempts + 1);

      // if (validatePassword().validate(passwordField1)) {
      //   throw new Error(
      //     "Your password should be between 8 and 100 characters, and have at least one lowercase and one uppercase letter."
      //   );
      // }

      if (passwordField1 !== passwordField2) {
        toast.error("Passwords do not match.");
        await Timeout.set(400);
        throw new Error("Passwords do not match.");
      }
      let data = {
        email,
        password,
        firstName,
        lastName,
        cartId: shopifyObj?.cart?.id,
      };
      const res = await fetch(`/api/register`, {
        method: "POST",
        body: JSON.stringify(data),
      });
      try {
        const response = await res.json();

        if (response.error) {
          toast.error(response.error);
          throw new Error(response.error);
        } else {
          updateCustomer(response, shopifyObj);
          // re-hydrate the cart so it contains the email
          // checkout.hydrate()
          setTimeout(() => {
            setShowRegisterComplete(true);
          }, 400);
          toast.success(`Welcome ${response.customer.firstName}!`);
        }
      } catch (err) {
        throw err;
      }
    },
    [passwordField1, passwordField2, attempts]
  );
  const { isPending, isReloading, load } = useLoads(
    "handleRegister",
    handleRegister as any,
    {
      defer: true,
    }
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // @ts-ignore
    const { email, password, firstName, lastName } = form!.current!.elements;
    load(email.value, password.value, firstName.value, lastName.value, shopify);
  };

  if (showRegisterComplete) {
    return (
      <Container
        height="100%"
        width="80%"
        margin="auto"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <h2>Sign up successful.</h2>
        <P textAlign="center">
          Thank you for creating an account, you are now logged in. You will
          receive an email shortly to confirm your email address.
        </P>
        <Button
          margin="30px 0 0 0"
          onClick={() => {
            navigate("/account");
            setTimeout(() => {
              closeDrawer();
              setShowRegisterComplete(false);
              setShowRegister(false);
            }, 400);
          }}
        >
          Go to account
        </Button>
        <TextButton
          underlined
          margin="30px 0 0 0"
          display="inline-block"
          onClick={() => {
            closeDrawer();
            setShowRegisterComplete(false);
            setShowRegister(false);
          }}
        >
          Close
        </TextButton>
      </Container>
    );
  }

  return (
    <Container
      height="100%"
      width="80%"
      margin="auto"
      justifyContent="center"
      alignItems="center"
    >
      <form onSubmit={e => handleSubmit(e)} ref={form}>
        <h2>Sign Up</h2>

        {/* {(isPending || isReloading) && <span>Loading</span>}
        {isRejected && <h1>ERROR</h1>} */}
        <GridContainer repeat={1} tabletRepeat={1} mobileRepeat={1} rowGap={20}>
          <div>
            <TextInput
              name="firstName"
              type="text"
              required={true}
              placeholder="First Name"
            />
          </div>
          <div>
            <TextInput
              name="lastName"
              type="text"
              required={true}
              placeholder="Last Name"
            />
          </div>
          <div>
            <TextInput
              name="email"
              type="text"
              required={true}
              placeholder="Enter Email"
            />
          </div>
          <div>
            <TextInput
              name="password"
              value={passwordField1}
              onChange={e => setPasswordField1(e.target.value)}
              type="password"
              required={true}
              placeholder="Password"
            />
          </div>
          <div>
            <TextInput
              name="passwordConfirm"
              value={passwordField2}
              onChange={e => setPasswordField2(e.target.value)}
              type="password"
              required={true}
              placeholder="Verify Password"
            />
          </div>

          <div>
            <Button margin="30px 0 0 0" type="submit">
              {isPending || isReloading ? "loading" : "Sign Up"}
            </Button>
            <div>
              Already have an account?{" "}
              <TextButton
                underlined
                margin="30px 0 0 0"
                display="inline-block"
                onClick={() => setShowRegister(false)}
              >
                Log in
              </TextButton>
            </div>
          </div>
        </GridContainer>
      </form>
    </Container>
  );
};
